import { render, staticRenderFns } from "./ContinueEditingBar.vue?vue&type=template&id=2fcc6071&"
import script from "./ContinueEditingBar.vue?vue&type=script&lang=js&"
export * from "./ContinueEditingBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports